const activeAppReducer = (state = null, action) => {
    switch (action.type) {

        case "ACTIVE_APP": 
            return action.payload;

        default :
            return state;
    }
}

export default activeAppReducer;
